import SettingsDispatcher from '~/flux/dispatchers/SettingsDispatcher';

const SettingsActions = {
  changeBrowserLanguage: function (new_lang, save_to_localstorage = true) {
    SettingsDispatcher.handleSettingsAction({
      actionType: SettingsDispatcher.CHANGE_BROWSER_LANGUAGE,
      new_lang,
      save_to_localstorage,
    });
  },

  saveSettings: function (settings) {
    SettingsDispatcher.handleSettingsAction({
      actionType: SettingsDispatcher.SAVE_SETTINGS,
      settings,
    });
  },

  toggleProfanityFilter: function () {
    SettingsDispatcher.handleSettingsAction({
      actionType: SettingsDispatcher.TOGGLE_PROFANITY_FILTER,
    });
  },
};
export default SettingsActions;
